import React from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { renderAsyncSelector } from '../../../../components/formik-components/FormAsyncSelector';
import useSubscriptionExpiredRestrictions from '../../../../hooks/useSubscriptionExpiredRestrictions';

const i18n = defineMessages({
  choose: { id: 'choose', defaultMessage: 'Choose' },
  save: { id: 'actions.save', defaultMessage: 'Save' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
});

const TargetJobEditForm = ({ toggleEdit, searchJobProfile, listJobProfiles, isJpLoading }) => {
  const { formatMessage } = useIntl();
  const { handleSubmit, isSubmitting, setFieldValue } = useFormikContext();
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  return (
    <Panel header={<FormattedMessage id="attrs.targetJob" defaultMessage="Target Job Profile" />}>
      <form className="form" onSubmit={handleSubmit}>
        <Field component="input" type="hidden" name="respondentId" />
        <div className="p-grid">
          <div className="p-col-12">
            <div className="form-group">
              <label className="field-label" htmlFor="superlink-jobProfileId">
                <FormattedMessage id="attrs.targetJob" defaultMessage="Target Job Profile" />
              </label>
              <Field
                id="job-profile-id"
                name="targetJob"
                component={renderAsyncSelector}
                processing={isJpLoading}
                data={listJobProfiles}
                filter
                valueField="id"
                textField="name"
                onSearch={searchJobProfile}
                setFieldValue={setFieldValue}
                placeholder={`- ${formatMessage(i18n.choose)} -`}
              />
            </div>
          </div>
          <div className="actions p-col-12">
            <Button
              type="submit"
              label={formatMessage(i18n.save)}
              icon={isSubmitting ? 'pi pi-spin pi-spinner' : ''}
              disabled={isSubmitting || subscriptionIsExpired}
            />
            <Button
              type="button"
              label={formatMessage(i18n.cancel)}
              onClick={() => toggleEdit('targetJob')}
              className="p-button-secondary"
            />
          </div>
        </div>
      </form>
    </Panel>
  );
};

TargetJobEditForm.propTypes = {
  toggleEdit: PropTypes.func.isRequired,
  searchJobProfile: PropTypes.func.isRequired,
  listJobProfiles: PropTypes.arrayOf(PropTypes.any).isRequired,
  isJpLoading: PropTypes.bool.isRequired,
};

export default TargetJobEditForm;
